module.exports = __webpack_public_path__ + "img/EurMillions_Ad2.f89c8ccd.png";